export default __webpack_public_path__ + "static/media/ovar.7412b2e5.png";